// ? [REVISIT] manually review this file
//@ts-nocheck

import '../../styles/templates/blog.practice.scss';

window.playVideo = function (videoElem, e) {
  const video = document.getElementById(videoElem);
  e.target.style.display = 'none';
  video.play();
  video.setAttribute('controls', 'true');
};

window.toggleTextCollapse = function (index, fullExcerpt, truncatedExcerpt) {
  const escapedFullExcerpt = fullExcerpt.replace(/'/g, '\\u0026#39;').replace('&#39;', '\\\u0026#39;');
  const escapedTruncatedExcerpt = truncatedExcerpt.replace(/'/g, '\\u0026#39;').replace('&#39;', '\\\u0026#39;');

  const textContainer = document.getElementById(`excerpt-${index}`);
  if (textContainer.getAttribute('data-extended') === 'false') {
    textContainer.innerHTML = `${fullExcerpt} <u class="read-more-less read-more-less-${index}" onclick="window.toggleTextCollapse(${index}, '${escapedFullExcerpt}', '${escapedTruncatedExcerpt}')"> Read Less</u>`;
    textContainer.setAttribute('data-extended', 'true');
  } else {
    textContainer.innerHTML = `${truncatedExcerpt} <u class="read-more-less read-more-less-${index}" onclick="window.toggleTextCollapse(${index}, '${escapedFullExcerpt}', '${escapedTruncatedExcerpt}')"> Read More</u>`;
    textContainer.setAttribute('data-extended', 'false');
  }
};
